// Tiny pub-sub used by <ToastContainer/> and toast() callers across the app.
// Mounting <ToastContainer/> once near the layout root receives every push.

const subscribers = new Set();

export const toastBus = {
  subscribe(fn) { subscribers.add(fn); },
  unsubscribe(fn) { subscribers.delete(fn); },
};

function emit(payload) {
  subscribers.forEach((fn) => fn(payload));
}

export function toast(payload) {
  emit({ tone: 'info', ...payload });
}

export const toasts = {
  success(title, message) { emit({ tone: 'success', title, message }); },
  error(title, message)   { emit({ tone: 'danger',  title, message }); },
  warning(title, message) { emit({ tone: 'warning', title, message }); },
  info(title, message)    { emit({ tone: 'info',    title, message }); },
};
